export default __webpack_public_path__ + "static/ay-glossary-havent-found-linkedin-ba7407e6212e6966b6f0907734d1c65d.svg";